/* eslint-disable react-refresh/only-export-components -- Einhängefunktion + private Komponente, kein HMR-Modul */
// Rückfall-Toaster: hängt sich selbst an document.body, wenn ein Toast kommt, aber die Shell `extraGlobals`
// (mit <ExtrasToaster/>) nicht rendert. Links navigieren dann ohne Router-Kontext (pushState + popstate).
import { createRoot } from 'react-dom/client';
import { setToastFallback, useToastStore } from './toast';
import { ToastList } from './ui';

/** Eigenständiger Toaster außerhalb des App-Baums; zeigt nur etwas, solange kein <ExtrasToaster/> eingehängt ist. */
function StandaloneToaster() {
  const hosts = useToastStore((s) => s.hosts);
  return hosts > 0 ? null : <ToastList standalone />;
}

let standaloneMounted = false;

/** Eigenständigen Toaster einmalig an document.body hängen (Rückfall, falls die Shell `extraGlobals` nicht rendert). */
export function mountStandaloneToaster(): void {
  if (standaloneMounted || typeof document === 'undefined') return;
  standaloneMounted = true;
  const el = document.createElement('div');
  el.dataset.testid = 'extras-standalone-toaster';
  document.body.appendChild(el);
  createRoot(el).render(<StandaloneToaster />);
}


// In Tests nicht automatisch einhängen (jeder Test rendert seinen eigenen Baum).
if (import.meta.env.MODE !== 'test') setToastFallback(mountStandaloneToaster);
